import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path, G, Defs, Rect, ClipPath } from "react-native-svg";
import AppTheme from "../../../AppTheme";
import MoodColors from "../MoodColors";

export default function GoodIcon(props) {
  const color = props.color || MoodColors.Good;
  const opacity = props.selected ? 1 : AppTheme.moodOpacity;
  const width = props.width || 36;
  const height = props.height || 36;

  return (
    <TouchableOpacity style={props.styles} {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G opacity={opacity} clipPath="url(#clip0_good)">
          <Path
            d="M30.7278 30.7279C37.7573 23.6985 37.7573 12.3015 30.7278 5.27208C23.6984 -1.75736 12.3014 -1.75736 5.27199 5.27208C-1.75745 12.3015 -1.75745 23.6985 5.27199 30.7279C12.3014 37.7574 23.6984 37.7574 30.7278 30.7279Z"
            fill={color}
          />
          <Path
            d="M25.0453 19.2755C25.9565 19.2755 26.6953 18.5368 26.6953 17.6255C26.6953 16.7143 25.9565 15.9755 25.0453 15.9755C24.134 15.9755 23.3953 16.7143 23.3953 17.6255C23.3953 18.5368 24.134 19.2755 25.0453 19.2755Z"
            fill={AppTheme.almostBlack}
          />
          <Path
            opacity="0.61"
            d="M25.3725 17.4137C25.6062 17.4137 25.7957 17.2242 25.7957 16.9905C25.7957 16.7568 25.6062 16.5674 25.3725 16.5674C25.1388 16.5674 24.9493 16.7568 24.9493 16.9905C24.9493 17.2242 25.1388 17.4137 25.3725 17.4137Z"
            fill="white"
          />
          <Path
            d="M28.5381 13.193C27.4493 11.9988 25.6647 11.4908 24.1106 11.9326"
            stroke={AppTheme.almostBlack}
            strokeWidth="0.928161"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <Path
            d="M8.47638 13.0741C9.55915 11.8748 11.3412 11.3583 12.8978 11.792"
            stroke={AppTheme.almostBlack}
            strokeWidth="0.928161"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <Path
            d="M11.8432 19.4341C12.7545 19.4341 13.4932 18.6954 13.4932 17.7841C13.4932 16.8729 12.7545 16.1341 11.8432 16.1341C10.9319 16.1341 10.1932 16.8729 10.1932 17.7841C10.1932 18.6954 10.9319 19.4341 11.8432 19.4341Z"
            fill={AppTheme.almostBlack}
          />
          <Path
            opacity="0.61"
            d="M12.2423 17.5723C12.476 17.5723 12.6654 17.3829 12.6654 17.1492C12.6654 16.9154 12.476 16.726 12.2423 16.726C12.0086 16.726 11.8191 16.9154 11.8191 17.1492C11.8191 17.3829 12.0086 17.5723 12.2423 17.5723Z"
            fill="white"
          />
          <Path
            d="M11.4632 25.1577C13.3442 27.0454 15.893 28.1164 18.5578 28.1387C21.2226 28.1611 23.7889 27.1331 25.7014 25.2772"
            stroke={AppTheme.almostBlack}
            strokeWidth="0.928161"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
        </G>
        <Defs>
          <ClipPath id="clip0_good">
            <Rect width="36" height="36" fill="white" />
          </ClipPath>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
